import { render, staticRenderFns } from "./next.vue?vue&type=template&id=bb6affe4&scoped=true&"
import script from "./next.vue?vue&type=script&lang=js&"
export * from "./next.vue?vue&type=script&lang=js&"
import style0 from "./next.vue?vue&type=style&index=0&id=bb6affe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6affe4",
  null
  
)

export default component.exports